module.exports = __webpack_public_path__ + "static/Firewatch8-1d39acb73cf6785c0f87b207c58ac4cb.webp";